module.exports = __webpack_public_path__ + "img/indeximg6.0e869f63.png";